import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';
import axios from 'axios';
import {
  H1,
  H2,
  PolicyLetterContainer,
  Main,
  PolicyLetterHeader,
  Label,
  PolicyLetterSection,
  PolicyLetterSectionColumn,
  ItemContainer,
  Disclaimer,
  PolicyContentTable,
} from '../components/lin/linSharedElements';
import { PaymentPlan } from './components';
import LinLogo from '../images/lin/lin_logo.png';

const MaxusView = () => {
  const [data, setData] = useState(null);
  const match = useRouteMatch('/p/:policyId');
  const notaryUrl = `${process.env.REACT_APP_NOTARY_URL}`;

  useEffect(() => {
    const getData = async () => {
      const dto = await axios.get(`${notaryUrl}/p/${match.params.policyId}`);
      setData(dto.data);
    };
    getData();
  }, [match.params.policyId, notaryUrl]);

  return (
    data && (
      <>
        <PolicyLetterContainer>
          <PolicyLetterHeader>
            <MaxusLogoImg src={LinLogo} alt='lin försäkring' />
            <MaxusH1>Försäkringsbrev Maxus Märkesförsäkring</MaxusH1>
          </PolicyLetterHeader>
          <Main>
            <PolicyLetterSection>
              <PolicyLetterSectionColumn>
                <MaxusItemContainer>
                  <MaxusLabel>Försäkringstagare:</MaxusLabel>
                  {data.name}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Försäkringsperiod:</MaxusLabel>
                  {data.answers.startDate} - {data.answers.endDate}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Registreringsnummer:</MaxusLabel>
                  {data.answers.registrationNumber}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Försäkringsnummer:</MaxusLabel>
                  {data.policyNumber}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Omfattning:</MaxusLabel>
                  {data.coverLevel}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Årlig körsträcka:</MaxusLabel>
                  {data.answers.mileage}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Boendeform:</MaxusLabel>
                  {data.answers.dwelling}
                </MaxusItemContainer>
              </PolicyLetterSectionColumn>
              <PolicyLetterSectionColumn>
                <MaxusItemContainer>
                  <MaxusLabel>Förare under 25 år:</MaxusLabel>
                  {data.answers.youngDriver}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Hyrbil</MaxusLabel>
                  {data.answers.optHiredCar ? 'Nej' : 'Ja'}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Djurkollision</MaxusLabel>
                  {data.answers.optAnimalCollision ? 'Nej' : 'Ja'}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Premie:</MaxusLabel>
                  {data.policyPremium.sumPremium}
                </MaxusItemContainer>
                <MaxusItemContainer>
                  <MaxusLabel>Trafikpremieskatt:</MaxusLabel>
                  {data.policyPremium.sumTax}
                </MaxusItemContainer>
              </PolicyLetterSectionColumn>
            </PolicyLetterSection>
            <MaxusDisclaimer>
              Detta försäkringsbrev beskriver din försäkring. Det är viktigt att
              du kontrollerar att de uppgifter vi har om dig och ditt fordon är
              korrekta eftersom de ligger till grund för din premie och hur
              mycket du betalar för din försäkring.
              <br />
              <br />
              Felaktiga uppgifter kan påverka ersättningen vid skada.
            </MaxusDisclaimer>
            <br />
            <br />
            <MaxusH2>Försäkringsinnehåll</MaxusH2>
            <PolicyLetterSection>
              <MaxusPolicyContentTable>
                <thead>
                  <tr>
                    <th>Moment</th>
                    <th>Självrisk</th>
                    <th>Viktig information</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>- Trafik</td>
                    <td>1 500 kr</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>- Stöld</td>
                    <td>2 000 kr</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>- Maskin</td>
                    <td>5 000 kr</td>
                    <td>
                      Om bilen gått maximalt 6 000 mil eller är maximalt 5 år
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>8 000 kr</td>
                    <td>
                      Om bilen gått mer än 6 000 mil eller är äldre än 5 år
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>
                      Gäller endast för fordon som är nyare än 8 år och som har
                      gått mindre än 10 000 mil
                    </td>
                  </tr>

                  <tr>
                    <td>- Brand</td>
                    <td>2 000 kr</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>- Glas</td>
                    <td>0 kr</td>
                    <td>Laga ett stenskott</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>30 %</td>
                    <td>Lägst 2 000 kr</td>
                  </tr>
                  <tr>
                    <td>- Räddning</td>
                    <td>1 750 kr</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>- Rättsskydd</td>
                    <td>20 %</td>
                    <td>Lägst 2 000 kr</td>
                  </tr>
                  <tr>
                    <td>- Vagnskada</td>
                    <td>4 000 kr</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>- Kristerapi</td>
                    <td>0 kr</td>
                    <td>Max 10 tillfällen under en 12-månadersperiod</td>
                  </tr>
                </tbody>
              </MaxusPolicyContentTable>
            </PolicyLetterSection>
            <br />
            <br />
            <MaxusH2>Betalningsplan</MaxusH2>
            <PaymentPlan
              ledgerData={data.paymentSchedule.schedule}
            ></PaymentPlan>
          </Main>
        </PolicyLetterContainer>
      </>
    )
  );
};

export default MaxusView;

const MaxusH1 = styled(H1)`
  font-family: 'din-condensed';
  font-weight: 400;
  color: #2b387e;
  font-size: 4rem;
`;

const MaxusH2 = styled(H2)`
  font-family: 'din-condensed';
  font-weight: 400;
  color: #2b387e;
  font-size: 2.4rem;
`;

const MaxusItemContainer = styled(ItemContainer)`
  font-family: 'din-condensed';
  font-weight: 400;
`;

const MaxusLabel = styled(Label)`
  font-weight: 300;
`;

const MaxusDisclaimer = styled(Disclaimer)`
  font-family: 'din-condensed';
  font-weight: 300;
`;

const MaxusPolicyContentTable = styled(PolicyContentTable)`
  font-family: 'din-condensed';
  font-weight: 300;

  thead {
    th {
      font-weight: 400;
    }
  }
`;

const MaxusLogoImg = styled.img`
  width: 9.6rem;
  height: auto;
  max-width: 28.8rem;
  margin: 1rem 0 3rem;
  border: 0;

  @media (min-width: 76.8rem) {
    margin: 4rem 0;
  }
`;
